import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { showNotification } from 'services/NotificationService';
import { isEmpty, isObject } from 'util/utils';
import { showDisSetting, searchDownloadLimit } from 'services/CommonApi';
import { SETTING_TYPE } from 'constants/Common';
import InputBlock from 'containers/InputBlock';

const defaultValues = {
  searchLimit: 50,
  downloadLimit: 10,
};

const validationSchema = Yup.object().shape({
  searchLimit: Yup.number().nullable(),
  downloadLimit: Yup.number().nullable(),
});

function LoginSetting() {
  const [setting, setSetting] = React.useState({});

  const initialValues = React.useMemo(() => {
    return Object.fromEntries(
      Object.entries(defaultValues).map(([key, value]) => [
        key,
        isEmpty(setting?.[key]) ? value : setting?.[key],
      ]),
    );
  }, [setting]);

  const getList = React.useCallback(async () => {
    const [, res] = await showDisSetting({ filter: { type: SETTING_TYPE.SEARCH_DOWNLOAD_LIMIT } });

    if (res?.code === 'OK' && isObject(res?.data)) {
      const data = res?.data;
      if (isObject(data) && (data.searchLimit != null || data.downloadLimit != null)) {
        setSetting({ searchLimit: data.searchLimit, downloadLimit: data.downloadLimit });
      }
    }
  }, []);

  React.useEffect(() => {
    getList();
  }, [getList]);

  const submitForm = React.useCallback(
    async (values, { setSubmitting }) => {
      setSubmitting(true);
      const [err, res] = await searchDownloadLimit(
        {
          type: SETTING_TYPE.SEARCH_DOWNLOAD_LIMIT,
          data: {
            searchLimit: Number(values.searchLimit) || defaultValues.searchLimit,
            downloadLimit: Number(values.downloadLimit) || defaultValues.downloadLimit,
          }
        });
      setSubmitting(false);
      if (!err) {
        showNotification(res);
        getList();
      }
    },
    [getList],
  );

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validateOnChange
      validationSchema={validationSchema}
      onSubmit={submitForm}
    >
      {({ handleChange, handleBlur, touched, errors, values }) => (
        <Form>
          <div className="d-flex homeSettingWrapper mt-20 loginSetting">
            <div className="userDropdown">
              <InputBlock
                type="number"
                name="searchLimit"
                label="Search Diamond Limit"
                placeholder="Search Diamond Limit"
                value={values.searchLimit}
                error={touched?.searchLimit && errors?.searchLimit}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </div>
            <div className="userDropdown">
              <InputBlock
                type="number"
                name="downloadLimit"
                label="Xlsx File Download Limit"
                placeholder="Xlsx File Download Limit"
                value={values.downloadLimit}
                error={touched?.downloadLimit && errors?.downloadLimit}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </div>
            <div className="width-100 d-flex mt-20">
              <button className="commonButton mr-10" type="submit" value="Submit">
                Save
              </button>
              <button
                className="commonButton mr-10"
                type="button"
                onClick={getList}
              >
                Reset
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default LoginSetting;
